var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pictureBackground"}},[_c('div',{attrs:{"id":"frame"}},[_c('img',{attrs:{"id":"picture","src":require(`../assets/${_vm.pictures[_vm.pictureIndex]}`)},on:{"click":_vm.changePicture}}),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"prompt"}},[_c('strong',[_vm._v("請點選畫框中的圖片")])])
}]

export { render, staticRenderFns }